
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CourseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CourseNode"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"promoImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imagePlaceholder"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSavedCourse"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"courseTag"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"textLabel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"textColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"preSale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"launchDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"duration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalLessons"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enrollments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"level"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"description"},"name":{"kind":"Name","value":"shortDescriptionWithoutHtml"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isEnrollment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"courseType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"courseTypeEnum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dashboardUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enrollmentUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enrollmentAccessPreviewUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"urlToBuyNow"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"catalogCategories"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"score"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"professor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"realPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discount"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"trailerSource"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"videoSourceType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isDefault"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"subtitleList"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subtitleFile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"languageCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isDefault"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":823}};
    doc.loc.source = {"body":"fragment CourseFragment on CourseNode {\n  originalId\n  title\n  promoImage\n  imagePlaceholder\n  isSavedCourse\n  courseTag {\n    textLabel\n    textColor\n    backgroundColor\n  }\n  preSale\n  launchDate\n  duration\n  totalLessons\n  enrollments\n  level {\n    originalId\n    slug\n    name\n  }\n  description: shortDescriptionWithoutHtml\n  isEnrollment\n  courseType\n  courseTypeEnum\n  url\n  dashboardUrl\n  enrollmentUrl\n  enrollmentAccessPreviewUrl\n  urlToBuyNow\n  catalogCategories {\n    originalId\n    name\n  }\n  score {\n    average\n  }\n  professor {\n    originalId\n    fullName\n    username\n  }\n  prices {\n    currencySymbol\n    price\n    realPrice\n    discount\n  }\n  trailerSource {\n    videoUrl\n    videoSourceType\n    imageUrl\n    isDefault\n  }\n  subtitleList {\n    subtitleFile\n    languageCode\n    isDefault\n  }\n  subtitle\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CourseFragment"] = oneQuery(doc, "CourseFragment");
        
